export const state = {
  organisme: undefined,
  organismes: [],
  typeOrganismes: [],
  organismeFonctions: [],
  pagination: { size: 100 }
}